/**
 * * `left` - Lewo
 * * `center` - Środek
 * * `right` - Prawo
 */
export type AlignmentEnum = 'left' | 'center' | 'right'

export type AnchorTypeEnum =
  | 'simplepage'
  | 'courseandeventpage'
  | 'locationpage'
  | 'attachment'
  | 'article'
  | 'url'

export type BlankEnum = ''

export type Contents = {
  id: string
  text: string
  items: Record<string, string>[]
}

/**
 * * `Beginner` - Początkujący
 * * `Advanced` - Zaawansowany
 * * `Expert` - Ekspert
 */
export type CourseLevelEnum = 'Beginner' | 'Advanced' | 'Expert'

export type CustomAuthToken = {
  token: string
}

export type CustomAuthTokenRequest = {
  /**
   * Hasło
   * @minLength 1
   */
  password: string
  /** @minLength 1 */
  email: string
}

/**
 * * `level` - Poziom
 * * `location` - Lokalizacja
 * * `teacher` - Nauczyciel
 * * `name` - Nazwa
 * * `participant_type` - Typ uczestnika
 */
export type FilterTypeEnum =
  | 'level'
  | 'location'
  | 'teacher'
  | 'name'
  | 'participant_type'

/**
 * * `left` - Lewo
 * * `center` - Środek
 * * `right` - Prawo
 */
export type HorizontalAlignmentEnum = 'left' | 'center' | 'right'

/**
 * * `no_margin` - Bez marginesu
 * * `small` - Mały
 * * `large` - Duży
 */
export type HorizontalMarginEnum = 'no_margin' | 'small' | 'large'

/**
 * * `parenting` - rodzicielskie wyzwania
 * * `weight-loss` - nadwagę
 * * `back-pain` - ból pleców
 * * `sleep` - sen
 * * `emotions` - emocje
 * * `mental-health` - spokój umysłu
 * * `fatigue` - poziom energii
 * * `success` - sukces w pracy
 * * `stress` - stres
 * * `concentration` - koncentrację
 */
export type IconsEnum =
  | 'parenting'
  | 'weight-loss'
  | 'back-pain'
  | 'sleep'
  | 'emotions'
  | 'mental-health'
  | 'fatigue'
  | 'success'
  | 'stress'
  | 'concentration'

export type LanguageChoice = {
  label: string
  /**
   * * `pl` - PL
   * * `en` - EN
   */
  value: ValueEnum
}

/**
 * * `small` - Mały
 * * `medium` - Średni
 * * `large` - Duży
 * * `none` - Brak
 */
export type MarginBottomEnum = 'small' | 'medium' | 'large' | 'none'

/**
 * * `small` - Mały
 * * `medium` - Średni
 * * `large` - Duży
 * * `none` - Brak
 */
export type MarginTopEnum = 'small' | 'medium' | 'large' | 'none'

export type PagesSitemapResponse = {
  simplepage: PublicSitemap[]
  article: PublicSitemap[]
  personpage: PublicSitemap[]
  locationpage: PublicSitemap[]
  courseandeventpage: PublicSitemap[]
  courseandeventdatepage: PublicSitemap[]
}

export type PaginatedPublicArticleList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicArticle[]
  /** @example 15 */
  page_size?: number
}

export type PaginatedPublicCourseAndEventDatePageList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicCourseAndEventDatePage[]
  /** @example 15 */
  page_size?: number
}

export type PaginatedPublicCourseAndEventPageList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicCourseAndEventPage[]
  /** @example 15 */
  page_size?: number
}

export type PaginatedPublicLocationPageList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicLocationPage[]
  /** @example 15 */
  page_size?: number
}

export type PaginatedPublicPersonPageList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicPersonPage[]
  /** @example 15 */
  page_size?: number
}

export type PaginatedPublicSimplePageResponseList = {
  /** @example 123 */
  count: number
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=4"
   */
  next?: string | null
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?page=2"
   */
  previous?: string | null
  results: PublicSimplePageResponse[]
  /** @example 15 */
  page_size?: number
}

/**
 * * `Adult` - Dorosły
 * * `Teenager` - Nastolatek
 * * `Kid` - Dziecko
 */
export type ParticipantTypeEnum = 'Adult' | 'Teenager' | 'Kid'

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicArticle = {
  id: string
  slug: string
  contents: Contents[]
  lead: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  /**
   * Data publikacji
   * @format date-time
   */
  publication_date?: string | null
  image: PublicImage
  tags: PublicTag[]
  author: PublicSimplePersonPage | null
  meta_keywords: string
  site_title: string
  meta_description: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicArticleDetail = {
  id: string
  slug: string
  contents: Contents[]
  lead: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  /**
   * Data publikacji
   * @format date-time
   */
  publication_date?: string | null
  image: PublicImage
  tags: PublicTag[]
  author: PublicSimplePersonPage | null
  meta_keywords: string
  site_title: string
  meta_description: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  link_to_all: string | null
}

export type PublicArticleListWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  all_available_tags: PublicTag[]
  /** @default "ArticleListWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicArticlesWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  title: string
  description: string
  items: SimplePublicArticle[]
  link_to_all: string | null
  /** @default "ArticlesWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicBannerWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  signature: string
  text: string
  /** @maxLength 12 */
  background_color: string
  image: PublicImage
  /** Obraz z prawej strony */
  is_flipped: boolean
  /** @default "BannerWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicButton = {
  id: number
  /**
   * * `primary` - Podstawowy
   * * `outline-black` - outline-black
   */
  color: PublicButtonColorEnum
  link: PublicLink
}

/**
 * * `primary` - Podstawowy
 * * `outline-black` - outline-black
 */
export type PublicButtonColorEnum = 'primary' | 'outline-black'

export type PublicButtonWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  /**
   * * `left` - Lewo
   * * `center` - Środek
   * * `right` - Prawo
   */
  alignment: AlignmentEnum
  buttons: PublicButton[]
  /** @default "ButtonWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicContactFormWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  title: string
  /** @default "ContactFormWidget" */
  resourcetype?: ResourcetypeEnum
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicCourseAndEventDatePage = {
  id: string
  slug: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_description: string
  site_title: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  meta_keywords: string
  image: PublicImage
  /** @format date */
  start_date: string
  /** @format date */
  end_date: string
  /** @maxLength 256 */
  city: string
  /** @maxLength 32 */
  currency: string
  /**
   * @min 0
   * @max 2147483647
   */
  course_fee: number
  /**
   * @min 0
   * @max 2147483647
   */
  early_course_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  early_repeaters_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  early_seniors_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  early_students_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  late_course_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  late_repeaters_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  late_senior_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  late_student_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  repeater_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  senior_fee?: number | null
  /**
   * @min 0
   * @max 2147483647
   */
  student_fee?: number | null
  /** @maxLength 256 */
  register_url: string
  teachers: Teacher[]
  full_slug: string
  course: SimpleCourseEventPage
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicCourseAndEventPage = {
  id: string
  slug: string
  name: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_description: string
  site_title: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  meta_keywords: string
  image: PublicImage
  /**
   * @min -2147483648
   * @max 2147483647
   */
  program_type_id: number
  /**
   * * `course` - Kurs
   * * `event` - Wydarzenie
   */
  type: TypeEnum
  /**
   * * `Beginner` - Początkujący
   * * `Advanced` - Zaawansowany
   * * `Expert` - Ekspert
   */
  course_level: CourseLevelEnum
  /**
   * * `Adult` - Dorosły
   * * `Teenager` - Nastolatek
   * * `Kid` - Dziecko
   */
  participant_type: ParticipantTypeEnum
  price_range: SimplePriceRange | null
  timetable_url: PublicLink
}

export type PublicCourseTile = {
  id: number
  course: SimplePublicCourseAndEventPage
  /**
   * @min 0
   * @max 2147483647
   */
  order?: number
}

export type PublicCourseTilesWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  courses: PublicCourseTile[]
  title: string
  description: string
  /** @default "CourseTilesWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicFaqItem = {
  id: number
  question: string
  answer: string
}

export type PublicFaqWidget = {
  margin_top: MarginTopEnum
  margin_bottom: MarginBottomEnum
  id: string
  title: string
  items: PublicFaqItem[]
  /** @default "FaqWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicFooterItem = {
  id: string
  label: string
  link: PublicLink
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicFooterMenu = {
  id: string
  items: PublicFooterItem[]
  contact_text: string
  footer_newsletter_enabled: boolean
}

export type PublicGalleryImage = {
  id: number
  image: PublicImage
}

export type PublicGalleryWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  title: string
  description: string
  images: PublicGalleryImage[]
  /** @default "GalleryWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicHeroWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  image: PublicImage
  video_video_id: string
  video_is_vimeo: boolean
  description: string
  title: string
  icons?: IconsEnum[]
  /** @default "HeroWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicHighlightedTextWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  text: string
  signature: string
  /** @default "HighlightedTextWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicImage = {
  id: string
  images: string
  alt: string
  title: string
  /** @format uri */
  file?: string
  height: number | null
  width: number | null
  is_svg: boolean
  /**
   * @minLength 2
   * @maxLength 2
   */
  ppoi_tuple: string[]
  /** @maxLength 7 */
  dominant_color?: string
  has_transparency?: boolean
}

export type PublicImageCard = {
  id: number
  title: string
  description: string
  image: PublicImage
  link: PublicLink
}

export type PublicImageCardsWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  cards: PublicImageCard[]
  /** @default "ImageCardsWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicImageWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  image: PublicImage
  caption: string
  /**
   * * `no_margin` - Bez marginesu
   * * `small` - Mały
   * * `large` - Duży
   */
  horizontal_margin?: HorizontalMarginEnum
  /** @default "ImageWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicImageWithMultipleLinksWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  image: PublicImage
  image_tablet: PublicImage
  image_mobile: PublicImage
  map_areas: PublicMapArea[]
  map_areas_tablet: PublicMapArea[]
  map_areas_mobile: PublicMapArea[]
  /** @default "ImageWithMultipleLinksWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicJotFormWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  /**
   * @format uri
   * @maxLength 200
   */
  form_url: string
  /** @default "JotFormWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicLargeTileWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  text: string
  title: string
  image: PublicImage
  link: PublicLink
  /** @default "LargeTileWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicLink = {
  anchor_type: AnchorTypeEnum
  anchor_id: string
  slug: string
  target_blank?: boolean
  widget?: string | null
  url: string
  video_id: string
  video_is_vimeo: boolean
  label: string
  /** @format uri */
  attachment_file: string
  icon: string
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicLocationPage = {
  id: string
  slug: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_description: string
  site_title: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  meta_keywords: string
  image: PublicImage
  description: string
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicLocationPageDetail = {
  id: string
  slug: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_description: string
  site_title: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  meta_keywords: string
  image: PublicImage
  description: string
  link_to_all: string | null
}

export type PublicLocationWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  locations: PublicLocationWidgetItem[]
  title: string
  description: string
  /** @default "LocationWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicLocationWidgetItem = {
  id: number
  location: PublicSimpleLocationPage
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicMainMenu = {
  id: string
  items: PublicMenuItem[]
  /**
   * Utworzony
   * @format date-time
   */
  created: string
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
}

export type PublicMapArea = {
  id: string
  /**
   * @format uri
   * @maxLength 200
   */
  url?: string
  title?: string
  /**
   * @min 0
   * @max 2147483647
   */
  x: number
  /**
   * @min 0
   * @max 2147483647
   */
  y: number
  /**
   * @min 0
   * @max 2147483647
   */
  width: number
  /**
   * @min 0
   * @max 2147483647
   */
  height: number
}

export type PublicMenuItem = {
  label: string
  link?: PublicLink | null
  items: PublicSecondLevelMenuItem[] | null
}

export type PublicMessage = {
  /** @maxLength 128 */
  first_name: string
  /** @maxLength 128 */
  last_name?: string
  /**
   * @format email
   * @maxLength 254
   */
  email: string
  /** @maxLength 500 */
  text: string
}

export type PublicMessageRequest = {
  /**
   * @minLength 1
   * @maxLength 128
   */
  first_name: string
  /** @maxLength 128 */
  last_name?: string
  /**
   * @format email
   * @minLength 1
   * @maxLength 254
   */
  email: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  text: string
}

export type PublicNewsletterAgreement = {
  id: string
  text: string
  is_required?: boolean
}

export type PublicNewsletterSettings = {
  id: string
  agreement: PublicNewsletterAgreement
  thanks_text: string
}

export type PublicNewsletterWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  title: string
  /** @default "NewsletterWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicPeopleWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  people: PublicPersonTile[]
  title: string
  description: string
  /** @default "PeopleWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicPerson = {
  id: number
  avatar: PublicImage
  full_name: string
  position: string
  description: string
  place: string
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicPersonPage = {
  id: string
  person: PublicPerson
  slug: string
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_keywords: string
  site_title: string
  meta_description: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicPersonPageDetail = {
  id: string
  person: PublicPerson
  slug: string
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_keywords: string
  site_title: string
  meta_description: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  link_to_all: string | null
}

export type PublicPersonTile = {
  id: number
  /**
   * @min 0
   * @max 2147483647
   */
  order?: number
  avatar: PublicImage
  page_slug: string
  position: string
  full_name: string
  description: string
  place: string
}

export type PublicQuoteWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  quote: string
  signature: string
  image: PublicImage
  /** @default "QuoteWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicSecondLevelMenuItem = {
  label: string
  link: PublicLink
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicSeoSettings = {
  id: string
  meta_title: string
  og_title: string
  meta_title_template: string
  meta_description: string
  og_description: string
  meta_keywords: string
  og_image: PublicImage
  favicon: PublicImage
  /** @format uri */
  favicon_ico: string
  gtm_id: string
  gtag_id: string
}

export type PublicSimpleLocationPage = {
  slug: string
  title: string
  description: string
  image: PublicImage
  is_hidden?: boolean
  absolute_url: string
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicSimplePageResponse = {
  id: string
  slug: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  widgets: PublicWidget[]
  meta_description: string
  site_title: string
  og_title: string
  og_description: string
  og_image: PublicImage
  is_menu_hidden?: boolean
  is_footer_hidden?: boolean
  /**
   * Zmodyfikowany
   * @format date-time
   */
  modified: string
  meta_keywords: string
}

export type PublicSimplePersonPage = {
  id: string
  name: string
  slug: string | null
}

/**
 * Mixin for parsing restql query from request.
 *
 * NOTE: We are using `request.GET` instead of
 * `request.query_params` because this might be
 * called before DRF request is created(i.e from dispatch).
 * This means `request.query_params` might not be available
 * when this mixin is used.
 */
export type PublicSiteSettings = {
  id: string
  /**
   * @format uri
   * @maxLength 200
   */
  facebook_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  twitter_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  youtube_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  instagram_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  linkedin_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  spotify_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  apple_url?: string
  /**
   * @format uri
   * @maxLength 200
   */
  google_url?: string
  logotype_desktop: PublicImage
  logotype_mobile: PublicImage
  widget_margins: string
  newsletter_settings: PublicNewsletterSettings
}

export type PublicSitemap = {
  /** @format date-time */
  modified: string
  slug_pl: string
  slug_en: string
}

export type PublicSubscribe = {
  /** @maxLength 255 */
  first_name: string
  /** @format email */
  email: string
  /** @default false */
  agreement?: boolean
  widget?: string | null
}

export type PublicSubscribeRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  first_name: string
  /**
   * @format email
   * @minLength 1
   */
  email: string
  /** @default false */
  agreement?: boolean
  /** @minLength 1 */
  widget?: string | null
}

export type PublicTag = {
  id: string
  name: string
  /**
   * * `blue` - Niebieski
   * * `green` - Zielony
   * * `navy` - Granatowy
   * * `yellow` - Żółty
   * * `blue-light` - Jasnoniebieski
   * * `green-light` - Jasnozielony
   */
  color?: TagColorEnum
}

export type PublicTextCard = {
  id: number
  title: string
  text: string
}

export type PublicTextWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  text: string
  horizontal_alignment?: HorizontalAlignmentEnum | BlankEnum
  /** @default "TextWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicThreeTextCardsWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  cards: PublicTextCard[]
  /** @default "ThreeTextCardsWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicTimetableWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  description: string
  title: string
  filter_type?: FilterTypeEnum | BlankEnum
  /** @maxLength 128 */
  filter_value?: string
  /** @default "TimetableWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicTwoColumnsTextWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  left_column_title: string
  left_column_text: string
  right_column_title: string
  right_column_text: string
  /** @default "TwoColumnsTextWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicVideoWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  title: string
  video_video_id: string
  video_is_vimeo: boolean
  /** @default "VideoWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicWidescreenImageWidget = {
  margin_top?: MarginTopEnum | BlankEnum
  margin_bottom?: MarginBottomEnum | BlankEnum
  id: string
  image: PublicImage
  video_video_id: string
  video_is_vimeo: boolean
  description: string
  title: string
  widescreen: boolean
  /** @default "WidescreenImageWidget" */
  resourcetype?: ResourcetypeEnum
}

export type PublicWidget =
  | PublicArticleListWidget
  | PublicContactFormWidget
  | PublicFaqWidget
  | PublicImageWidget
  | PublicImageWithMultipleLinksWidget
  | PublicNewsletterWidget
  | PublicTextWidget
  | PublicVideoWidget
  | PublicTwoColumnsTextWidget
  | PublicHighlightedTextWidget
  | PublicThreeTextCardsWidget
  | PublicLargeTileWidget
  | PublicButtonWidget
  | PublicQuoteWidget
  | PublicBannerWidget
  | PublicImageCardsWidget
  | PublicGalleryWidget
  | PublicHeroWidget
  | PublicWidescreenImageWidget
  | PublicLocationWidget
  | PublicCourseTilesWidget
  | PublicTimetableWidget
  | PublicPeopleWidget
  | PublicArticlesWidget
  | PublicJotFormWidget

/**
 * * `ArticleListWidget` - ArticleListWidget
 * * `ContactFormWidget` - ContactFormWidget
 * * `FaqWidget` - FaqWidget
 * * `ImageWidget` - ImageWidget
 * * `ImageWithMultipleLinksWidget` - ImageWithMultipleLinksWidget
 * * `NewsletterWidget` - NewsletterWidget
 * * `TextWidget` - TextWidget
 * * `VideoWidget` - VideoWidget
 * * `TwoColumnsTextWidget` - TwoColumnsTextWidget
 * * `HighlightedTextWidget` - HighlightedTextWidget
 * * `ThreeTextCardsWidget` - ThreeTextCardsWidget
 * * `LargeTileWidget` - LargeTileWidget
 * * `ButtonWidget` - ButtonWidget
 * * `QuoteWidget` - QuoteWidget
 * * `BannerWidget` - BannerWidget
 * * `ImageCardsWidget` - ImageCardsWidget
 * * `GalleryWidget` - GalleryWidget
 * * `HeroWidget` - HeroWidget
 * * `WidescreenImageWidget` - WidescreenImageWidget
 * * `LocationWidget` - LocationWidget
 * * `CourseTilesWidget` - CourseTilesWidget
 * * `TimetableWidget` - TimetableWidget
 * * `PeopleWidget` - PeopleWidget
 * * `ArticlesWidget` - ArticlesWidget
 * * `JotFormWidget` - JotFormWidget
 */
export type ResourcetypeEnum =
  | 'ArticleListWidget'
  | 'ContactFormWidget'
  | 'FaqWidget'
  | 'ImageWidget'
  | 'ImageWithMultipleLinksWidget'
  | 'NewsletterWidget'
  | 'TextWidget'
  | 'VideoWidget'
  | 'TwoColumnsTextWidget'
  | 'HighlightedTextWidget'
  | 'ThreeTextCardsWidget'
  | 'LargeTileWidget'
  | 'ButtonWidget'
  | 'QuoteWidget'
  | 'BannerWidget'
  | 'ImageCardsWidget'
  | 'GalleryWidget'
  | 'HeroWidget'
  | 'WidescreenImageWidget'
  | 'LocationWidget'
  | 'CourseTilesWidget'
  | 'TimetableWidget'
  | 'PeopleWidget'
  | 'ArticlesWidget'
  | 'JotFormWidget'

export type SimpleCourseEventPage = {
  id: string
  slug: string | null
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_pl?: string
  /**
   * Slug
   * @maxLength 512
   * @pattern ^[-a-zA-Z0-9_]+$
   */
  slug_en?: string
  title: string
  image?: string | null
  /**
   * * `Beginner` - Początkujący
   * * `Advanced` - Zaawansowany
   * * `Expert` - Ekspert
   */
  course_level: CourseLevelEnum
  price_range: SimplePriceRange | null
  /**
   * * `Adult` - Dorosły
   * * `Teenager` - Nastolatek
   * * `Kid` - Dziecko
   */
  participant_type: ParticipantTypeEnum
  /**
   * @min -2147483648
   * @max 2147483647
   */
  program_type_id: number
  name: string
}

export type SimplePriceRange = {
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  min: string
  /**
   * @format decimal
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  max: string
  currency: string | null
}

export type SimplePublicArticle = {
  id: string
  title: string
  description: string
  image: PublicImage
  absolute_url: string
}

export type SimplePublicCourseAndEventPage = {
  title: string
  name: string
  image: PublicImage
  slug: string
  /**
   * * `Beginner` - Początkujący
   * * `Advanced` - Zaawansowany
   * * `Expert` - Ekspert
   */
  course_level: CourseLevelEnum
}

/**
 * * `blue` - Niebieski
 * * `green` - Zielony
 * * `navy` - Granatowy
 * * `yellow` - Żółty
 * * `blue-light` - Jasnoniebieski
 * * `green-light` - Jasnozielony
 */
export type TagColorEnum =
  | 'blue'
  | 'green'
  | 'navy'
  | 'yellow'
  | 'blue-light'
  | 'green-light'

export type Teacher = {
  id: number
  full_name: string
  /**
   * @format email
   * @maxLength 254
   */
  email: string
  avatar: PublicImage | null
}

export type TextChoice = {
  label: string
  value: string
}

/**
 * * `course` - Kurs
 * * `event` - Wydarzenie
 */
export type TypeEnum = 'course' | 'event'

/**
 * * `pl` - PL
 * * `en` - EN
 */
export type ValueEnum = 'pl' | 'en'

import type { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || ''
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] =
        property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        )
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {})
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path
      })
      .then(response => response.data)
  }
}

type Flatten<T> = T extends any[] ? T[number] : T
type ChangeTypeOfKeys<T extends object, Keys extends keyof T, NewType> = {
  [key in keyof T]: key extends Keys ? NewType : T[key]
}
type MapObjectKeysToTrue<ObjectType extends Record<PropertyKey, any>> = {
  [key in keyof ObjectType]?: ObjectType[key] extends Record<PropertyKey, any>
    ? true | MapObjectKeysToTrue<Flatten<ObjectType[key]>>
    : true
}
type FetchKeysType = { [key in PropertyKey]: true | FetchKeysType }
type FetchKeys<ResponseModel> = ResponseModel extends {
  count?: number
  results?: Array<infer DataModel>
}
  ? DataModel extends Record<PropertyKey, any>
    ? MapObjectKeysToTrue<DataModel>
    : DataModel
  : ResponseModel extends Record<PropertyKey, any>
  ? MapObjectKeysToTrue<Flatten<ResponseModel>>
  : ResponseModel

type NestedSafePick<ResponseModel, FetchKeysType> = ResponseModel extends Array<
  infer Model
>
  ? NestedSafePick<Model, FetchKeysType>[]
  : {
      [key in keyof FetchKeysType]: FetchKeysType[key] extends Record<
        PropertyKey,
        any
      >
        ? key extends keyof ResponseModel
          ? ResponseModel[key] extends Array<infer DataModel>
            ? NestedSafePick<DataModel, FetchKeysType[key]>[]
            : NestedSafePick<ResponseModel[key], FetchKeysType[key]>
          : never
        : key extends keyof ResponseModel
        ? ResponseModel[key] extends Array<infer DataModel>
          ? DataModel[]
          : ResponseModel[key]
        : never
    }

type PickKeys<ResponseModel, FetchKeysType> = {} extends FetchKeysType
  ? ResponseModel
  : ResponseModel extends {
      count?: number
      results?: Array<infer DataModel>
    }
  ? ChangeTypeOfKeys<
      ResponseModel,
      'results',
      NestedSafePick<DataModel, FetchKeysType>[]
    >
  : ResponseModel extends Array<infer DataModel>
  ? NestedSafePick<DataModel, FetchKeysType>[]
  : NestedSafePick<ResponseModel, FetchKeysType>

function postprocessQuery(query?: any) {
  if (!query) return query

  const parsedQuery = query
  if (query.fetchKeys) {
    function getStringifiedQueryKeys(keys: FetchKeysType) {
      let query = '{'
      Object.entries(keys).forEach(([key, value], index) => {
        if (typeof value === 'object') {
          const keyToAdd = `${key}${getStringifiedQueryKeys(value)}`
          query += index > 0 ? `,${keyToAdd}` : keyToAdd
        } else {
          query += index > 0 ? `,${key}` : key
        }
      })
      return query + '}'
    }

    parsedQuery.query = getStringifiedQueryKeys(query.fetchKeys)
  }

  delete parsedQuery.fetchKeys
  return parsedQuery
}

/**
 * @title API* @version 1.0.0 (v1)*/
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  public = {
    /**
     * No description
     *
     * @tags public
     * @name PublicContactMessageCreate
     * @request POST:/public/contact/message/
     * @secure
     */
    publicContactMessageCreate: <T extends FetchKeys<PublicMessage>>(
      data: PublicMessageRequest,
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicMessage, T>, any>({
        path: `/public/contact/message/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
    /**
     * No description
     *
     * @tags public
     * @name PublicCoreLanguagesList
     * @request GET:/public/core/languages/
     * @secure
     */,
    publicCoreLanguagesList: <T extends FetchKeys<LanguageChoice[]>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<LanguageChoice[], T>, any>({
        path: `/public/core/languages/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicCoreSeoSettingsRetrieve
     * @request GET:/public/core/seo-settings/
     * @secure
     */,
    publicCoreSeoSettingsRetrieve: <T extends FetchKeys<PublicSeoSettings>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicSeoSettings, T>, any>({
        path: `/public/core/seo-settings/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicCoreSettingsRetrieve
     * @request GET:/public/core/settings/
     * @secure
     */,
    publicCoreSettingsRetrieve: <T extends FetchKeys<PublicSiteSettings>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicSiteSettings, T>, any>({
        path: `/public/core/settings/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * No description
     *
     * @tags public
     * @name PublicImagesIconsRetrieve
     * @request GET:/public/images/icons/
     * @secure
     */,
    publicImagesIconsRetrieve: <T extends FetchKeys<void>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<void, T>, any>({
        path: `/public/images/icons/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicMenuFooterRetrieve
     * @request GET:/public/menu/footer/
     * @secure
     */,
    publicMenuFooterRetrieve: <T extends FetchKeys<PublicFooterMenu>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicFooterMenu, T>, any>({
        path: `/public/menu/footer/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicMenuMainRetrieve
     * @request GET:/public/menu/main/
     * @secure
     */,
    publicMenuMainRetrieve: <T extends FetchKeys<PublicMainMenu>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicMainMenu, T>, any>({
        path: `/public/menu/main/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * No description
     *
     * @tags public
     * @name PublicNewsletterSubscribeCreate
     * @request POST:/public/newsletter/subscribe/
     * @secure
     */,
    publicNewsletterSubscribeCreate: <T extends FetchKeys<PublicSubscribe>>(
      data: PublicSubscribeRequest,
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicSubscribe, T>, any>({
        path: `/public/newsletter/subscribe/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesArticlesList
     * @request GET:/public/pages/articles/
     * @secure
     */,
    publicPagesArticlesList: <T extends FetchKeys<PaginatedPublicArticleList>>(
      query?: {
        author?: string
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number
        tags?: string[]

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicArticleList, T>, any>({
        path: `/public/pages/articles/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesArticlesRetrieve
     * @request GET:/public/pages/articles/{slug}/
     * @secure
     */,
    publicPagesArticlesRetrieve: <T extends FetchKeys<PublicArticleDetail>>(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicArticleDetail, T>, any>({
        path: `/public/pages/articles/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesCourseAndEventsList
     * @request GET:/public/pages/course-and-events/
     * @secure
     */,
    publicPagesCourseAndEventsList: <
      T extends FetchKeys<PaginatedPublicCourseAndEventPageList>
    >(
      query?: {
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number
        /** A search term. */
        search?: string

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicCourseAndEventPageList, T>, any>({
        path: `/public/pages/course-and-events/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesCourseAndEventsDatesList
     * @request GET:/public/pages/course-and-events-dates/
     * @secure
     */,
    publicPagesCourseAndEventsDatesList: <
      T extends FetchKeys<PaginatedPublicCourseAndEventDatePageList>
    >(
      query?: {
        course?: string
        level?: string
        location?: string
        name?: string
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number
        participant_type?: string
        teacher?: string

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicCourseAndEventDatePageList, T>, any>(
        {
          path: `/public/pages/course-and-events-dates/`,
          method: 'GET',
          query: postprocessQuery(query),
          secure: true,
          format: 'json',
          ...params
        }
      )
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesCourseAndEventsDatesRetrieve
     * @request GET:/public/pages/course-and-events-dates/{slug}/
     * @secure
     */,
    publicPagesCourseAndEventsDatesRetrieve: <
      T extends FetchKeys<PublicCourseAndEventDatePage>
    >(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicCourseAndEventDatePage, T>, any>({
        path: `/public/pages/course-and-events-dates/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesCourseAndEventsDatesFilterOptionsList
     * @request GET:/public/pages/course-and-events-dates/filter-options/
     * @secure
     */,
    publicPagesCourseAndEventsDatesFilterOptionsList: <
      T extends FetchKeys<TextChoice[]>
    >(
      query?: {
        course?: string
        /** Filter options to be fetched. */
        filter?: string
        level?: string
        location?: string
        name?: string
        participant_type?: string
        teacher?: string

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<TextChoice[], T>, any>({
        path: `/public/pages/course-and-events-dates/filter-options/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesCourseAndEventsRetrieve
     * @request GET:/public/pages/course-and-events/{slug}/
     * @secure
     */,
    publicPagesCourseAndEventsRetrieve: <
      T extends FetchKeys<PublicCourseAndEventPage>
    >(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicCourseAndEventPage, T>, any>({
        path: `/public/pages/course-and-events/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesLocationsList
     * @request GET:/public/pages/locations/
     * @secure
     */,
    publicPagesLocationsList: <
      T extends FetchKeys<PaginatedPublicLocationPageList>
    >(
      query?: {
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number
        /** A search term. */
        search?: string

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicLocationPageList, T>, any>({
        path: `/public/pages/locations/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesLocationsRetrieve
     * @request GET:/public/pages/locations/{slug}/
     * @secure
     */,
    publicPagesLocationsRetrieve: <
      T extends FetchKeys<PublicLocationPageDetail>
    >(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicLocationPageDetail, T>, any>({
        path: `/public/pages/locations/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesPeopleList
     * @request GET:/public/pages/people/
     * @secure
     */,
    publicPagesPeopleList: <T extends FetchKeys<PaginatedPublicPersonPageList>>(
      query?: {
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicPersonPageList, T>, any>({
        path: `/public/pages/people/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesPeopleRetrieve
     * @request GET:/public/pages/people/{slug}/
     * @secure
     */,
    publicPagesPeopleRetrieve: <T extends FetchKeys<PublicPersonPageDetail>>(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicPersonPageDetail, T>, any>({
        path: `/public/pages/people/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesSimplePagesList
     * @request GET:/public/pages/simple-pages/
     * @secure
     */,
    publicPagesSimplePagesList: <
      T extends FetchKeys<PaginatedPublicSimplePageResponseList>
    >(
      query?: {
        /** A page number within the paginated result set. */
        page?: number
        /** Number of results to return per page. */
        page_size?: number
        /** A search term. */
        search?: string

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PaginatedPublicSimplePageResponseList, T>, any>({
        path: `/public/pages/simple-pages/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * @description Mixin for parsing restql query from request. NOTE: We are using `request.GET` instead of `request.query_params` because this might be called before DRF request is created(i.e from dispatch). This means `request.query_params` might not be available when this mixin is used.
     *
     * @tags public
     * @name PublicPagesSimplePagesRetrieve
     * @request GET:/public/pages/simple-pages/{slug}/
     * @secure
     */,
    publicPagesSimplePagesRetrieve: <
      T extends FetchKeys<PublicSimplePageResponse>
    >(
      slug: string,
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PublicSimplePageResponse, T>, any>({
        path: `/public/pages/simple-pages/${slug}/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * No description
     *
     * @tags public
     * @name PublicPagesSitemapRetrieve
     * @request GET:/public/pages/sitemap/
     * @secure
     */,
    publicPagesSitemapRetrieve: <T extends FetchKeys<PagesSitemapResponse>>(
      query?: { fetchKeys?: T },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<PagesSitemapResponse, T>, any>({
        path: `/public/pages/sitemap/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
    /**
     * No description
     *
     * @tags public
     * @name PublicUsersTokenLoginCreate
     * @request POST:/public/users/token/login/
     * @secure
     */,
    publicUsersTokenLoginCreate: <T extends FetchKeys<CustomAuthToken>>(
      data: CustomAuthTokenRequest,
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<CustomAuthToken, T>, any>({
        path: `/public/users/token/login/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
  schema = {
    /**
     * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     *
     * @tags schema
     * @name SchemaRetrieve
     * @request GET:/schema/
     * @secure
     */
    schemaRetrieve: <T extends FetchKeys<Record<string, any>>>(
      query?: {
        format?: 'json' | 'yaml'
        lang?: 'en' | 'pl'

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<Record<string, any>, T>, any>({
        path: `/schema/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
  }
  schemaPublic = {
    /**
     * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     *
     * @tags schema-public
     * @name SchemaPublicRetrieve
     * @request GET:/schema-public/
     * @secure
     */
    schemaPublicRetrieve: <T extends FetchKeys<Record<string, any>>>(
      query?: {
        format?: 'json' | 'yaml'
        lang?: 'en' | 'pl'

        fetchKeys?: T
      },
      params: RequestParams = {}
    ) =>
      this.request<PickKeys<Record<string, any>, T>, any>({
        path: `/schema-public/`,
        method: 'GET',
        query: postprocessQuery(query),
        secure: true,
        format: 'json',
        ...params
      })
  }
}
